import React, { Dispatch, FC, SetStateAction } from 'react'

export type TaskGroupDotsMenu = {
  setEditingNotes: Dispatch<SetStateAction<boolean>>
}

export const TaskGroupDotsMenu: FC<TaskGroupDotsMenu> = (props) => {
  const { setEditingNotes } = props

  return (
    <div className='px-3 py-1 border border-gray-200 rounded-md bg-white w-max'>
      <p
        className='p-px text-primary text-[12px] hover:bg-sky-300 cursor-pointer'
        onClick={() => setEditingNotes(true)}
      >
        Add Stage Note
      </p>
    </div>
  )
}
